import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			investorsNewsListLinkListItemCls: string;
			investorsNewsListPagingCls: string;
		}
	},

	slug: string
}

class List extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Investors News List Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsNewsListPagingCls || '', 'investors_news_list', { animCls: 'animate__fadeIn', once: true});

		if(this.publicVars.cssId.anim?.investorsNewsListLinkListItemCls) {

			const investorsNewsItemsCount = document.querySelectorAll(
				this.publicVars.cssId.anim?.investorsNewsListLinkListItemCls).length;

			for (let i = 1; i <= investorsNewsItemsCount; i++) {
				scroll.registerAnimatedElement(`${this.publicVars.cssId.anim?.investorsNewsListLinkListItemCls}${i}`,
					'investors_news_list', { animCls: 'animate__fadeInLeft25P', once: true });
			}
		}
	}

	bind() {
		this.msg('bind');
	}
}

export default List;